/**
 * API endpoints for students
 */
export class StudentsAPI {
    apiClient;
    controllerUrl;
    /**
     * Create a new StudentsAPI
     * @param apiClient - The API client
     * @param baseUrl - The base URL for API requests
     */
    constructor(apiClient, baseUrl) {
        this.apiClient = apiClient;
        this.controllerUrl = `${baseUrl}/Students`;
    }
    /**
     * Get a student by ID
     * @param userId - The user ID
     * @returns Promise with the student
     */
    async getStudent(userId) {
        const url = `/${userId}`;
        return this.apiClient.get(this.controllerUrl + url);
    }
    /**
     * Get a student's subscriptions
     * @param userId - The user ID
     * @returns Promise with the subscriptions
     */
    async getStudentSubscriptions(userId) {
        const url = `/${userId}/subscriptions`;
        return this.apiClient.get(this.controllerUrl + url);
    }
    async updateAvatar(userId, dna) {
        return this.apiClient.put(this.controllerUrl + `/${userId}`, { dna });
    }
    async postStudent(body) {
        return this.apiClient.post(this.controllerUrl + "/", body);
    }
}
